export default "/fonts/vendor/katex/dist/KaTeX_Caligraphic-Regular.woff?db074fa22cf224af93d7b2122b1fab93";